<template>
  <div class="container">
    <div class="wrapper">
      <div class="header"><img src="./img/bg2.png" alt=""></div>

      <!-- 显示奖品前 -->
      <div class="card" v-if="!showGetCard">
        <img class="card-pic" src="./img/envelope-close.png" alt="">
        <transition name="fade">
          <div class="card-before" v-show="card.showBefore">距离大年三十开红包还有<span class="card-before-days">{{ card.daysRemaining }}</span>天</div>
        </transition>
        <transition name="fade">
          <div class="card-festival" v-show="card.showFestival">大年三十开红包啦</div>
        </transition>
        <div class="card-btn">
          <transition name="fade"><img src="./img/btn-off.png" v-show="card.showBefore" @click="openTips('活动尚未开启')" alt=""></transition>
          <transition name="fade"><img src="./img/btn-on.png" v-show="card.showFestival" :class="{ 'active-flips': hasGetReward }" @click="getReward" alt=""></transition>
        </div>
      </div>

      <!-- 显示奖品 -->
      <div class="card" v-else>
        <img class="card-pic" src="./img/envelope-open.png" alt="">
        <div class="card-reward" v-show="currentReward.reward_type2 == 'vip'">
          <div class="card-reward-title">{{ hasGetRewardText }}</div>
          <div class="card-reward-text">{{ currentReward.reward_num2 }}天VIP</div>
        </div>
        <div class="card-reward" v-show="currentReward.reward_type2 == 'bk'">
          <div class="card-reward-title">{{ hasGetRewardText }}</div>
          <div class="card-reward-text">{{ currentReward.reward_num2 }}个贝壳</div>
        </div>
        <div class="card-reward-story" v-show="currentReward.reward_type2 == 'audio'">
          <div class="card-reward-story-title">{{ hasGetRewardText }}</div>
          <div class="card-reward-story-pic" @click="goListen(12365)"></div>
          <div class="card-reward-story-text">新年故事礼包</div>
        </div>
      </div>

      <div class="desc">
        <div class="desc-title"><span>活动说明</span></div>
        <div class="desc-text">1. 每人可有1次拆红包机会；</div>
        <div class="desc-text">2. 红包内有口袋故事VIP会员、贝壳、故事礼包等；</div>
        <div class="desc-text">3. 仅限大年三十（1月24日）当天0点-24点可拆；</div>
      </div>
      <div class="footer">本活动解释权归口袋故事所有，如有疑问可咨询在线客服（家长页》帮助中心》在线客服）</div>
    </div>

    <div class="tips" v-show="tips.visible">{{ tips.text }}</div>

    <div class="over" v-show="card.showOver">
      <img src="@/assets/global/icon-over.png" alt="">
      <span>来晚啦，活动结束啦</span>
    </div>

    <transition name="fade"><div class="mask" v-show="maskVisible"></div></transition>

  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { sendTraceLog } from '@/api/trace'
import { getRule, getRewardStatus, getReward, getChannelRewardList } from '@/api/reward'

/**
 * wt1/正式环境配置数据
 * 渠道标识：daniansanshi	(id：192)
 * 奖励id、奖励天数、中奖概率：
 * 114 1天vip 60.9%
 * 111 3天VIP 11%
 * 112 7天VIP 3%
 * 113 30天VIP 0.1%
 * 115 88贝壳 5%
 * 116 故事礼包 20%
 */

export default {
  name: 'RedEnvelope2020',
  data () {
    return {
      rewardList: [],
      currentReward: {},
      probability: {
        '111': 110,
        '112': 30,
        '113': 1,
        '114': 609,
        '115': 50,
        '116': 200
      },
      hasGetReward: false,
      hasGetRewardText: '恭喜你获得',
      showGetCard: false,
      card: {
        showBefore: false,
        showFestival: false,
        showOver: false,
        daysRemaining: '--'
      },
      tips: { text: '', visible: false },
      maskVisible: false
    }
  },
  async created () {
    this.handleDays()
    await this.getChannelRewardList()
    await this.getRewardStatus()
  },
  methods: {
    handleDays () {
      this.card.daysRemaining = moment('2020-01-24').diff(moment(this.currentDate).format('YYYY-MM-DD'), 'days') // 距离春节的天数
      if (this.card.daysRemaining == 0) {
        this.card.showFestival = true
      } else if (this.card.daysRemaining > 0) {
        this.card.showBefore = true
      } else if (this.card.daysRemaining < 0) {
        this.card.showOver = true
        this.maskVisible = true
      }
    },
    async getChannelRewardList () {
      if (this.card.daysRemaining != 0) return
      try {
        let { list } = await getChannelRewardList(this.channelId, this.userId)
        this.rewardList = list || []
      } catch (e) {
        console.error(e)
      }
    },
    async getRewardStatus () {
      if (this.card.daysRemaining != 0) return
      try {
        let data = await getRewardStatus(this.channelId, this.userId)
        if (+data.status === 1) {
          // 已领奖
          this.currentReward = this.rewardList.find(item => {
            return +item.reward_id === +data.reward_id
          }) || {}
          this.hasGetReward = true
          this.hasGetRewardText = '您已经获得'
          console.log('hasget', this.currentReward)
        } else {
          // 未领奖
          this.randomDrawPrize()
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getReward () {
      if (this.hasGetReward) return
      try {
        let data = await getReward(this.currentReward.reward_id, this.userId)
        if (+data.retcode === 1) {
          sendTraceLog('open_reward', {
            event_name: 'red-envelope-2020',
            obj_type: 'reward',
            obj_id: this.currentReward.reward_id
          }, this.userId)
          this.hasGetReward = true
        } else {
          this.openTips('请稍后再试')
        }
      } catch (e) {
        this.openTips('请稍后再试')
        console.error(e)
      }
    },
    getRandomIntInclusive (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min //含最大值，含最小值
    },
    randomDrawPrize () {
      let n = this.getRandomIntInclusive(1, 1000)
      let arr = Object.keys(this.probability).map(key => {
        return {
          key,
          interval: this.probability[key]
        }
      })
      for(let i in arr) {
        arr[i].interval = arr[i].interval + (arr[i - 1] && arr[i - 1].interval || 0)
      }
      this.currentReward = this.rewardList.find(item => {
        return +item.reward_id === +this.recursiveMathInterval(n, arr)
      }) || {}
      console.log(`随机数n：${n}`)
      console.log('区间：', arr,)
      console.log('分配奖品：', this.currentReward)
    },
    recursiveMathInterval (n, arr) {
      for(let i in arr) {
        if (n <= arr[i].interval) {
          return arr[i].key
        }
      }
      return 0
    },
    goListen () {
      window.location.href = `ilisten:///audio/info?id=${this.currentReward.reward_value2 || '12365'}`
    },
    openTips (text = '', duration = 3000) {
      if (this.tips.visible) return
      this.tips = {
        text: text,
        visible: true
      }
      setTimeout(() => {
        this.tips = {
          text: '',
          visible: false
        }
      }, duration)
    },
  },
  computed: {
    ...mapGetters([
      'token',
      'userId',
      'mobile',
      'nickname',
      'avatarUrl',
      'isVip',
      'vipCount',
      'isSub'
    ]),
    channelId () {
      return this.$route.query.channel_id || 'daniansanshi'
    },
    currentDate () {
      return this.$route.query.current_date || undefined
    }
  },
  watch: {
    hasGetReward (nval, oval) {
      if (nval) {
        setTimeout(() => {
          this.showGetCard = true
        }, 800)
      }
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  min-height: 100vh;
  background: #D1302D;
  .wrapper {
    min-height: 100vh;
    padding-bottom: .6rem;
    background: url('./img/bg1.jpg') no-repeat;
    background-size: 100% auto;
    .header {
      padding-top: 6%;
      img {
        width: 100%;
      }
    }
    .card {
      margin-top: -.4rem;
      position: relative;
      &-pic {
        width: 100%;
      }
      &-before {
        font-size: .3rem;
        color: #fff;
        &-days {
          font-size: .4rem;
          color: #FFE8B2;
          line-height: 21px;
        }
      }
      &-festival {
        font-size: .34rem;
        color: #FFD300;
      }
      &-before, &-festival {
        white-space: nowrap;
        position: absolute;
        top: 1.4rem;
        top: 16%;
        left: 50%;
        transform: translateX(-50%);
      }
      &-btn {
        position: absolute;
        width: 2.56rem;
        left: 50%;
        top: 30%;
        transform: translateX(-50%);
        img {
          width: 100%;
        }
      }

      &-reward {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // flex-direction: column;
        position: absolute;
        top: 15%;
        left: 50%;
        transform: translateX(-50%);
        &-title {
          font-size: .48rem;
          font-weight: bold;
          color: #DE8D00;
          text-align: center;
        }
        &-text {
          margin-top: .2rem;
          font-size: .68rem;
          font-weight: bold;
          color: #F8000D;
          text-align: center;
        }
      }
      &-reward-story {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // flex-direction: column;
        position: absolute;
        top: 7%;
        left: 50%;
        transform: translateX(-50%);
        &-title {
          margin-top: .1rem;
          font-size: .48rem;
          font-weight: bold;
          color: #DE8D00;
          text-align: center;
        }
        &-pic {
          width: 2rem;
          height: 2rem;
          margin: 0 auto;
          margin-top: .2rem;
          background: url('./img/reward-pic.jpg') no-repeat;
          background-size: 100% 100%;
        }
        &-text {
          margin-top: .2rem;
          font-size: .28rem;
          font-weight: bold;
          color: #DE8D00;
          text-align: center;
        }
      }
    }
    .desc {
      width: 80%;
      margin: .3rem auto;
      &-title {
        margin-bottom: .2rem;
        text-align: center;
        span {
          font-size: .36rem;
          color: #FFD78E;
          text-align: center;
          position: relative;
          &::before {
            content: '';
            height: .05rem;
            width: .05rem;
            position: absolute;
            top: 50%;
            right: 1.7rem;
            transform: translateY(-50%);
            background: #FFD78E;
          }
          &::after {
            content: '';
            height: .05rem;
            width: .05rem;
            position: absolute;
            top: 50%;
            left: 1.7rem;
            transform: translateY(-50%);
            background: #FFD78E;
          }
        }
      }
      &-text {
        font-size: .26rem;
        color: #FFE8B2;
        line-height: .34rem * 2;
      }
    }
    .footer {
      width: 80%;
      margin: 0 auto;
      padding: .2rem .24rem;
      background: #EB3B38;
      border-radius: 8px;
      font-size: .24rem;
      color: #FFAA00;
    }
  }
  .tips {
    z-index: 100;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: scaleDraw 0.7s ease-in-out;
    padding: .2rem .3rem;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.8);
    border-radius: .2rem;
    font-size: .3rem;
    color: #FFF;
    text-align: center;
  }
  @keyframes scaleDraw {
    0% {
      transform: translate(-50%, -50%) scale(0);
    }
    50% {
      transform: translate(-50%, -50%) scale(1.1);
    }
    100% {
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .active-flips {
    animation: flips .6s linear forwards;
  }
  @keyframes flips {
    0% {
      transform: rotateY(0deg) scale(1);
    }
    50% {
      transform: rotateY(180deg) scale(1.2);
    }
    100% {
      transform: rotateY(360deg) scale(1.3);
    }
  }
  .over {
    width: 80%;
    padding: .5rem;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    background: #fff;
    color: #000;
    font-size: .4rem;
    text-align: center;
    border-radius: 20px;
    z-index: 100;
    img {
      position: relative;
      top: -1.4rem;
      width: 100%;
    }
    span {
      display: block;
      position: relative;
      top: -.6rem;
    }
  }
}
</style>
